<!-- Betűzés visszafelé teszt kiértékelés ACE-R -->


<div *ngIf="wrResult.gameType == 'ACE-R' || wrResult.gameType == 'AKV'"  class="d-flex flex-column align-items-center">

    <div class="drawingContainer-flexi bg-white p-3 my-2 w-50 mx-auto">
        <div class="d-flex flex-column align-items-center mb-3">
            <div class="d-flex justify-content-center align-items-center w-100">
                <h5>{{wrResult.sentence1}}</h5>
            </div>

            <audio controls="" *ngIf="audioUrl1" class="w-100">
                <source [src]="audioUrl1" type="audio/wav">
            </audio>

        </div>
        <div class="mb-3">
            <!-- <div class="form-label">{{ 'Game.Job' | translate:locale.language }}</div> -->
            <dx-text-box stylingMode="filled" [(value)]="wrResult.sentence2" valueChangeEvent="keyup"
                (onValueChanged)="handleValueChange($event)">
            </dx-text-box>
            <br>
            {{ 'Core.Result' | translate:locale.language }}: {{wrResult.result1}}
        </div>

    </div>

</div>


<!-- Betűzés visszafelé teszt kiértékelés -->

<div *ngIf="wrResult.gameType != 'ACE-R' && wrResult.gameType != 'AKV'" class="d-flex flex-column align-items-center">

    <div class="drawingContainer-flexi bg-white p-3 my-2 w-50 mx-auto">
        <div class="d-flex flex-column align-items-center mb-3">
            <div class="d-flex justify-content-center align-items-center w-100">
                <h5>{{wrResult.sentence1}}</h5>
            </div>

            <!-- <audio controls="" *ngIf="blobUrl1" class="w-100">
                <source [src]="sanitize(blobUrl1)" type="audio/wav">
            </audio> -->
            <audio controls="" *ngIf="audioUrl1" class="w-100">
                <source [src]="audioUrl1" type="audio/wav">
            </audio>


        </div>
        <div class="d-block d-sm-flex justify-content-center align-items-center">
            <div class="card w-50 m-2">
                <div class="card-body text-center">
                    <h4>{{wrResult.sentence1[4]}}</h4>
                    <div>
                        <dx-check-box [(value)]="wrResult.result1">
                        </dx-check-box>
                    </div>
                </div>
            </div>
            <div class="card w-50 m-2">
                <div class="card-body text-center">
                    <h4>{{wrResult.sentence1[3]}}</h4>
                    <div>
                        <dx-check-box [(value)]="wrResult.result2">
                        </dx-check-box>
                    </div>
                </div>
            </div>
            <div class="card w-50 m-2">
                <div class="card-body text-center">
                    <h4>{{wrResult.sentence1[2]}}</h4>
                    <div>
                        <dx-check-box [(value)]="wrResult.result3">
                        </dx-check-box>
                    </div>
                </div>
            </div>
            <div class="card w-50 m-2">
                <div class="card-body text-center">
                    <h4>{{wrResult.sentence1[1]}}</h4>
                    <div>
                        <dx-check-box [(value)]="wrResult.result4">
                        </dx-check-box>
                    </div>
                </div>
            </div>
            <div class="card w-50 m-2">
                <div class="card-body text-center">
                    <h4>{{wrResult.sentence1[0]}}</h4>
                    <div>
                        <dx-check-box [(value)]="wrResult.result5">
                        </dx-check-box>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error | translate:locale.language}}</div>
